const SetInnerHtml = (props) => {
    const {html} = props;
    if (html === "<p><br></p>")
        return;

    return (
        <div
            dangerouslySetInnerHTML={{
                __html: html
            }}
            {...props}
        />
    )
};

export default SetInnerHtml;

